module.exports = __webpack_public_path__ + "static/media/samsung_960@2x.b4b46b30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gear/workstation/samsung_960@2x.png
// module id = 315
// module chunks = 0